import { Routes } from 'src/lib/constants';
import { ExperimentsReducer } from 'src/redux/reducers/experiments';

export type Experiment = {
  id: string;
  variant: Record<string, string>;
};

export const CCIN_NEW_BIG_PURCHASE_FLOW: Experiment = {
  id: 'CCIN-1583_cardfinder_big_purchase_v2',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_NEW_BUILD_CREDIT_FLOW: Experiment = {
  id: 'CCIN-1354_cardfinder_build_credit_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_NEW_BALANCE_TRANSFER_FLOW: Experiment = {
  id: 'CCIN-1517_cf_balance_transfer_v2_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_REGISTER_FLOW: Experiment = {
  id: 'ccin-974_register-flow_experiment',
  variant: {
    CONTROL: 'off',
    VARIANT: 'on',
  },
};

export const CCIN_HIDE_RECOMMENDATIONS: Experiment = {
  id: 'CCIN-1106_hide_recommendations_v2_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_SHOW_INTERNATIONAL_PARTNERS: Experiment = {
  id: 'CCIN-757_cardfinder_-_travel_v2',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_NERDY_TIPS_AND_PROGRESS_BAR: Experiment = {
  id: 'CCIN-1255_nerdy_tips_and_progress_bar_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_CARDFINDER_BRANDED_LP: Experiment = {
  id: 'ccin-1257_cardfinder_branded_lp_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_LIMITED_CREDIT_CHICLET: Experiment = {
  id: 'CCIN-1303_limited_credit_chiclet_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_PROGRESS_BAR_ONLY: Experiment = {
  id: 'CCIN-1486_cf_progress_bar_only_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_REWARDS_PRODUCT_CARD: Experiment = {
  id: 'CCIN-1945_rewards_product_card_cardfinder_experiment',
  variant: {
    CONTROL: 'control',
    VARIANT: 'treatment',
  },
};

export const CCIN_AUTH0: Experiment = {
  id: 'CCIN-2347-auth0',
  variant: {
    CONTROL: 'page_variant',
    VARIANT: 'popup_variant',
  },
};

const EXPERIMENTS = {
  [Routes.Flow]: [
    CCIN_REGISTER_FLOW,
    CCIN_NERDY_TIPS_AND_PROGRESS_BAR,
    CCIN_NEW_BUILD_CREDIT_FLOW,
    CCIN_NEW_BALANCE_TRANSFER_FLOW,
    CCIN_PROGRESS_BAR_ONLY,
    CCIN_AUTH0,
  ],
  [Routes.Results]: [
    CCIN_HIDE_RECOMMENDATIONS,
    CCIN_LIMITED_CREDIT_CHICLET,
    CCIN_NEW_BUILD_CREDIT_FLOW,
    CCIN_NEW_BALANCE_TRANSFER_FLOW,
  ],
  [Routes.Jump]: [CCIN_CARDFINDER_BRANDED_LP],
};

export const isExperimentActive = (
  experiments: ExperimentsReducer,
  experimentName: string,
  variant: string
) => experiments?.[experimentName]?.variant === variant;

export const isNewBigPurchaseFlowExperimentActive = (
  experiments: ExperimentsReducer
) => false;

export const isNewBuildCreditFlowExperimentActive = (
  experiments: ExperimentsReducer
) => false;

export const isNewBalanceTransferFlowExperimentActive = (
  experiments: ExperimentsReducer
) => false;
export const isAuth0PageExperimentActive = (auth0Variant?: string): boolean =>
  auth0Variant === CCIN_AUTH0.variant.CONTROL;
export const isAuth0PopupExperimentActive = (auth0Variant?: string): boolean =>
  auth0Variant === CCIN_AUTH0.variant.VARIANT;
export const isAuth0ExperimentActive = (auth0Variant?: string): boolean =>
  isAuth0PageExperimentActive(auth0Variant) ||
  isAuth0PopupExperimentActive(auth0Variant);

export const isHideRecommendationsExperimentActive = (
  experiments: ExperimentsReducer
): boolean =>
  isExperimentActive(
    experiments,
    CCIN_HIDE_RECOMMENDATIONS.id,
    CCIN_HIDE_RECOMMENDATIONS.variant.VARIANT
  );

export const isShowInternationalPartnersExperimentsActive = (
  experiments: ExperimentsReducer
): boolean => false;

export const isNerdyTipAndProgressBarActive = (
  experiments: ExperimentsReducer
) =>
  isExperimentActive(
    experiments,
    CCIN_NERDY_TIPS_AND_PROGRESS_BAR.id,
    CCIN_NERDY_TIPS_AND_PROGRESS_BAR.variant.VARIANT
  );

export const isCardfinderBrandedLpActive = (experiments: ExperimentsReducer) =>
  false;

export const isLimitedCreditChicletExperimentActive = (
  experiments: ExperimentsReducer
) =>
  isExperimentActive(
    experiments,
    CCIN_LIMITED_CREDIT_CHICLET.id,
    CCIN_LIMITED_CREDIT_CHICLET.variant.VARIANT
  );

export const isProgressBarOnlyActive = (experiments: ExperimentsReducer) =>
  true;

const getExperimentList = (route: Routes) =>
  EXPERIMENTS[route].map(({ id }) => id);

export default getExperimentList;
